import { IKogIcon } from '@/main/@types/interfaceIcons';
import React from 'react';
import styled from 'styled-components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const AreaIcon = styled.div`
  position: relative;
  width: fit-content;
  .cart-icon{
    font-size: 10rem;
  }
  .check-icon {
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 3rem;
  }
`;

export function CartCheckIcon({
  height = '50px',
  width = '50px',
  color = 'currentColor'
}: IKogIcon) {
  return (
    <AreaIcon>
      <ShoppingCartIcon className="cart-icon" />
      <CheckCircleIcon className="check-icon" color="primary" />
    </AreaIcon>
  );
}
